// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1eb-H5Ow","header":"_3FhQWBWi","header-mobile":"_2boBvowr","overlay":"_1A7bIahQ","content":"oiOo51DS","columns-container":"_2U9XZ1Xc","leftCol":"_3khfsNMt","middleCol":"RD4OQXSz","rightCol":"_47OyNnwr","details-container":"_1lBhFOhc","colUl":"_2_fB-V7M","sentence":"_3i5K8Zlu","buttonDown":"_3Y1Y8mqD","arrowIcon":"_14hK4Nr_"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/HeaderSection/HeaderSection.styl
// module id = 208
// module chunks = 0